import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';




const Contact = (props)=>  {
    const [name, setname] = useState("") 
    const [lname, setlname] = useState("") 
    const [email, setemail] = useState("") 
    const [subject, setsubject] = useState("") 
    const [Message, setMessage] = useState("") 
    const [data, setdata] = useState([]) 
    const [data1, setdata1] = useState([]) 
    const [fg , setfg] = useState(true)
    const [fvalue , setfvalue] = useState([])


   useEffect(()=>{
    window.scrollTo(0, 0)

    fetch("https://paint-saudi-rayidh-main-back.vercel.app/FAQ",{
        method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res3=>res3.json())
        .then(res4=>{
            let dat1 = []
            res4.map((res55,c)=>{
                dat1.push(0)
            })
            setfvalue(dat1)
               setdata(res4)
               data.map((res,i)=>{
                data1[i] = res.text
               })

            console.log(res4)
          })
          return () => {
            document.getElementById("get1").classList.remove("is-active");
            document.getElementById("get2").style.display = "none";
          }
        },[])

      
        
const setChangerItemSize = (e)=>{

    if (fg) setfg(false)
    else setfg(true)

    for (let i = 0; i < 45; i++) {
      if(i === e){
        if(fvalue[e] === 0){
            fvalue[e] = 1
            // let f = document.getElementById("changeIcon"+i)
             document.getElementById("changeIcon1"+i).style.transform = "rotate(180deg)"
            
        }
        else {
            fvalue[e] = 0
            // let v = document.getElementById("changeIcon"+i)
             document.getElementById("changeIcon1"+i).style.transform = "rotate(0deg)"
            // v.innerHTML= ""
         }
      }
   
    }
  
  setfvalue(fvalue)
    if (fg) setfg(false)
    else setfg(true)
    
}
    



        return (
       <div>
  <div className="site-section">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <center>
            <h2 className="h3 mb-5 mt-5 text-black">كيف يمكننا مساعدتك؟</h2>
          </center>
        </div>

        {/* ITEM 1 */}
        <div className="border p-3 mb-3" style={{ margin: "0px 14px" }}>
          <div
            style={{ display: "flex" }}
            onClick={() => setChangerItemSize(1)}
            href="#collapsefaq1"
            aria-controls="collapsefaq1"
            data-toggle="collapse"
          >
            <span style={{ color: "black", marginRight: "20px", marginTop: "-4px" }}>▼</span>
            <h3 className="h6 mb-0">
              <a
                className="d-block"
                data-toggle="collapse"
                href="#collapsefaq1"
                role="button"
                aria-expanded="false"
                aria-controls="collapsefaq1"
                style={{ color: "black" }}
              >
                ما هي طرق الدفع المتاحة؟
              </a>
            </h3>
          </div>
          <div className="collapse" id="collapsefaq1">
            <div className="py-2">
              <p className="mb-0">
                نقبل عدة طرق للدفع، مثل البطاقات البنكية، التحويلات المصرفية، والدفع عند الاستلام.
                يمكنكم زيارة صفحة الدفع لمعرفة أحدث التفاصيل.
              </p>
            </div>
          </div>
        </div>

        {/* ITEM 2 */}
        <div className="border p-3 mb-3" style={{ margin: "0px 14px" }}>
          <div
            style={{ display: "flex" }}
            onClick={() => setChangerItemSize(2)}
            href="#collapsefaq2"
            aria-controls="collapsefaq2"
            data-toggle="collapse"
          >
            <span style={{ color: "black", marginRight: "20px", marginTop: "-4px" }}>▼</span>
            <h3 className="h6 mb-0">
              <a
                className="d-block"
                data-toggle="collapse"
                href="#collapsefaq2"
                role="button"
                aria-expanded="false"
                aria-controls="collapsefaq2"
                style={{ color: "black" }}
              >
                كيف يمكنني تتبع طلبي؟
              </a>
            </h3>
          </div>
          <div className="collapse" id="collapsefaq2">
            <div className="py-2">
              <p className="mb-0">
                بعد شحن الطلب، يتم إرسال رقم تتبع عبر البريد الإلكتروني.
                يمكنكم إدخال الرقم في موقعنا لمعرفة حالة الطلب.
              </p>
            </div>
          </div>
        </div>

        {/* ITEM 3 */}
        <div className="border p-3 mb-3" style={{ margin: "0px 14px" }}>
          <div
            style={{ display: "flex" }}
            onClick={() => setChangerItemSize(3)}
            href="#collapsefaq3"
            aria-controls="collapsefaq3"
            data-toggle="collapse"
          >
            <span style={{ color: "black", marginRight: "20px", marginTop: "-4px" }}>▼</span>
            <h3 className="h6 mb-0">
              <a
                className="d-block"
                data-toggle="collapse"
                href="#collapsefaq3"
                role="button"
                aria-expanded="false"
                aria-controls="collapsefaq3"
                style={{ color: "black" }}
              >
                ما هي سياسة الاسترجاع؟
              </a>
            </h3>
          </div>
          <div className="collapse" id="collapsefaq3">
            <div className="py-2">
              <p className="mb-0">
                نقدم سياسة استرجاع خلال 14 يومًا للمنتجات غير المستخدمة.
                يرجى التواصل مع خدمة العملاء لبدء عملية الاسترجاع.
              </p>
            </div>
          </div>
        </div>

        {/* ITEM 4 */}
        <div className="border p-3 mb-3" style={{ margin: "0px 14px" }}>
          <div
            style={{ display: "flex" }}
            onClick={() => setChangerItemSize(4)}
            href="#collapsefaq4"
            aria-controls="collapsefaq4"
            data-toggle="collapse"
          >
            <span style={{ color: "black", marginRight: "20px", marginTop: "-4px" }}>▼</span>
            <h3 className="h6 mb-0">
              <a
                className="d-block"
                data-toggle="collapse"
                href="#collapsefaq4"
                role="button"
                aria-expanded="false"
                aria-controls="collapsefaq4"
                style={{ color: "black" }}
              >
                هل تقدمون خدمة الشحن الدولي؟
              </a>
            </h3>
          </div>
          <div className="collapse" id="collapsefaq4">
            <div className="py-2">
              <p className="mb-0">
                نعم، نوفر خدمة الشحن الدولي إلى بعض الدول.
                تختلف تكلفة الشحن ومدة التوصيل حسب الموقع.
              </p>
            </div>
          </div>
        </div>

        {/* ITEM 5 */}
        <div className="border p-3 mb-3" style={{ margin: "0px 14px" }}>
          <div
            style={{ display: "flex" }}
            onClick={() => setChangerItemSize(5)}
            href="#collapsefaq5"
            aria-controls="collapsefaq5"
            data-toggle="collapse"
          >
            <span style={{ color: "black", marginRight: "20px", marginTop: "-4px" }}>▼</span>
            <h3 className="h6 mb-0">
              <a
                className="d-block"
                data-toggle="collapse"
                href="#collapsefaq5"
                role="button"
                aria-expanded="false"
                aria-controls="collapsefaq5"
                style={{ color: "black" }}
              >
                كيف يمكنني التواصل مع خدمة العملاء؟
              </a>
            </h3>
          </div>
          <div className="collapse" id="collapsefaq5">
            <div className="py-2">
              <p className="mb-0">
                يمكنكم التواصل مع خدمة العملاء عبر الهاتف على:
                <br />
                📞 058 381 2793
                <br />
                أو زيارة فرعنا في الرياض.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

        )
    
}


export default Contact;






